import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { BaseComponent } from '../../../abstracts/base.abstract';
import { ISelectChoices } from '../../../interfaces/generic-select-config.interface';
import { EnumsState } from '../../../store/state/enums.state';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
})
export class RoleComponent extends BaseComponent implements OnInit {
    @Select(EnumsState.rolesChoices) public rolesChoices$: Observable<ISelectChoices[]>;
    @Input() public group: FormGroup;
    @Input() public readonly = false;
    @Output() public elementSizeModification = new EventEmitter<void>();

    public rolesChoices: ISelectChoices[];
    public maxRolesNumber = 2;

    ngOnInit(): void {
        this.uns = this.rolesChoices$.subscribe((roles: ISelectChoices[]) => {
            this.rolesChoices = roles;
        });
    }

    public resetRole(): void {
        this.secondaryRole.patchValue('');
    }

    public get mainRole(): FormControl {
        return this.group.get('mainRole') as FormControl;
    }

    public get secondaryRole(): FormControl {
        return this.group.get('secondaryRole') as FormControl;
    }
}
